var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProfilePhone = function SvgProfilePhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4016 16.1458L18.3314 13.0756C17.2349 11.9791 15.3709 12.4178 14.9323 13.8432C14.6033 14.83 13.5068 15.3783 12.52 15.1589C10.327 14.6107 7.36651 11.7598 6.81827 9.45721C6.48932 8.47033 7.14721 7.37384 8.13405 7.04493C9.55949 6.60634 9.99808 4.74231 8.9016 3.64582L5.83143 0.575656C4.95424 -0.191885 3.63846 -0.191885 2.87091 0.575656L0.787587 2.65898C-1.29574 4.85196 1.00689 10.6633 6.16038 15.8168C11.3139 20.9703 17.1253 23.3826 19.3182 21.1896L21.4016 19.1063C22.1691 18.2291 22.1691 16.9133 21.4016 16.1458Z",
    fill: "#8F97B9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfilePhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile_phone.88adbeaf.svg";
export { ForwardRef as ReactComponent };